import{a as i}from"./chunk-TIVE5C2A.js";import{b as t,c as e}from"./chunk-IFH5QFUJ.js";import{a as n}from"./chunk-SUHZKQC4.js";import{m as o}from"./chunk-HBP5N4FR.js";o();e();n();function s(r){i.dispatch(t({address:r,loginMethod:"extra"}))}export{s as a};
//# sourceMappingURL=chunk-FZTRSZKD.js.map
